import React from "react";
import { STHead, STContactUs } from "@/components";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("contact-us");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching contact-us page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

const ContactUs = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "Contact Us";
  const metaDescription =
    pageContent.meta_description ||
    "Partnerships is the foundational core for developing advanced biomaterails at Sustanix. We work with the industry, for the industry to transition to a circular economy without any green premium";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Sustanix contact, green chemistry, sustainable additives, support";

  const ogTitle = pageContent.og_title || metaTitle;
  const ogDescription = pageContent.og_description || metaDescription;
  const ogKeywords = pageContent.og_keywords || metaKeywords;

  const getOgImage = () => {
    if (pageContent.og_image_url) return pageContent.og_image_url;
    if (pageContent.og_image) {
      if (
        pageContent.og_image.startsWith("http://") ||
        pageContent.og_image.startsWith("https://") ||
        pageContent.og_image.startsWith("/")
      ) {
        return pageContent.og_image;
      }
      return imageUrlBase.endsWith("/")
        ? `${imageUrlBase}${pageContent.og_image}`
        : `${imageUrlBase}/${pageContent.og_image}`;
    }
    return "https://sustanix.com/opengraph-image.webp";
  };

  const ogImage = getOgImage();

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/contact-us/"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com/contact-us/"
        ogImage={ogImage}
        ogType="website"
      />
      <STContactUs pageData={pageData} />
    </>
  );
};

export default ContactUs;

